import React, { Component } from "react";
//
import loadScript from "./loadScript";

export default function withAsyncScript(
  WrappedComponent,
  libUrl,
  libName,
  query = {}
) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {};
      loadScript(libName, libUrl, query).then(this.libLoaded.bind(this));
    }

    libLoaded({ lib, libName }) {
      this.setState({
        lib,
        libName
      });
    }

    render() {
      const { lib, libName } = this.state;

      if (!lib) return null;

      const props = { ...this.props, [libName]: lib };

      return <WrappedComponent {...props} />;
    }
  };
}
